import React from 'react';
import {Button, FormControl, FormGroup, Image} from 'react-bootstrap';

const rating1 = require('../../images/rating/rating-1.png');
const rating2 = require('../../images/rating/rating-2.png');
const rating3 = require('../../images/rating/rating-3.png');
const rating4 = require('../../images/rating/rating-4.png');
const rating5 = require('../../images/rating/rating-5.png');

class Vote extends React.PureComponent {

  constructor(props) {
    super(props);

    this.onVoteClick = this.onVoteClick.bind(this);
  }

  onVoteClick(e) {
    e.preventDefault();
    this.props.onClick(this.props.value);
  }

  render() {
    return <button disabled={this.props.submitting} onClick={this.onVoteClick} className={this.props.rating === this.props.value ? `selected-${this.props.value}` : ''}>
      <Image src={this.props.img} height={85} className="grow" />
      <div>{this.props.value}</div>
    </button>;
  }
}

class FeedbackForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      content: '',
      hover: 0,
      rating: 0,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.onVoteClick = this.onVoteClick.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.onSubmit(this.state);
  }

  onVoteClick(value) {
    this.setState({rating: value});
  }

  render() {

    return <form onSubmit={this.handleSubmit}>
      <h1 style={{textAlign: "center"}}>{this.props.translate('duringStaySurvey.feedbackQuestion')}</h1>
      <h4 style={{textAlign: "center", fontStyle: 'italic'}}>{this.props.translate('duringStaySurvey.feedbackQuestionSubtitle')}</h4>
      <div className="rating">
        <Vote img={rating1} value={1} onClick={this.onVoteClick} rating={this.state.rating} submitting={this.props.submitting} />
        <Vote img={rating2} value={2} onClick={this.onVoteClick} rating={this.state.rating} submitting={this.props.submitting} />
        <Vote img={rating3} value={3} onClick={this.onVoteClick} rating={this.state.rating} submitting={this.props.submitting} />
        <Vote img={rating4} value={4} onClick={this.onVoteClick} rating={this.state.rating} submitting={this.props.submitting} />
        <Vote img={rating5} value={5} onClick={this.onVoteClick} rating={this.state.rating} submitting={this.props.submitting} />
      </div>
      {!!this.state.rating && <React.Fragment>
        <div className="feedback"><FormGroup controlId="formControlsTextarea">
          <FormControl componentClass="textarea"
                       placeholder={this.props.translate(`duringStaySurvey.placeholder-rating-${this.state.rating}`)}
                       onChange={e => this.setState({content: e.target.value})}
                       disabled={this.props.submitting}

          />
        </FormGroup>
        </div>

        <div>
          <Button
            type="submit"
            className="submitButton"
            disabled={this.props.submitting}>
            <span>{this.props.translate('duringStaySurvey.sendSurvey')}</span>
            <span className="fa fa-heart"/>
          </Button>
        </div>
      </React.Fragment>
      }
    </form>;
  }
}

export default FeedbackForm;



// WEBPACK FOOTER //
// ./components/during-stay-survey/FeedbackForm.js